export default __webpack_public_path__ + "static/media/file.d46a62e7.svg";